<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("products.productFound") }}
      </p>
    </header>

    <section class="modal-card-body">
      <p class="has-text-centered">
        {{ $t("products.instructionsToAddProduct") }}
      </p>
      <br />

      <h2
        class="subtitle has-text-danger has-text-centered"
        v-if="product.status === 'pending'"
      >
        {{ $t("products.attention") }}
        <br />
        {{ $t("products.productUnderReview") }}
      </h2>

      <b-table :data="[product]" narrowed id="products-table">
        <b-table-column field="b" :label="$t('products.code')" v-slot="props">
          {{ props.row.b }}
        </b-table-column>

        <b-table-column field="n" :label="$t('common.name')" v-slot="props">
          {{ props.row.n }}
        </b-table-column>

        <b-table-column :label="$t('products.price')">
          <money
            v-model="p"
            v-bind="money"
            class="input"
            style="width: 150px"
          ></money>
        </b-table-column>

        <b-table-column
          :label="$t('products.vipPrice')"
          :visible="
            storeBeingManaged.configs.vipActive &&
              permissions.seeProductVipPriceMerchonii &&
              permissions.updateProductVipPriceMerchonii
          "
        >
          <money
            v-model="vp"
            v-bind="money"
            class="input"
            style="width: 150px"
          ></money>
        </b-table-column>

        <b-table-column
          v-if="storeHasVAT"
          field="vat"
          :label="$t('products.%vat')"
        >
          <b-select v-model="vat" :disabled="!permissions.manageTaxes">
            <option v-for="v in getVatValues" :value="v.value">{{
              v.name
            }}</option>
          </b-select>
        </b-table-column>
      </b-table>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="addToCatalog"
      >
        {{ $t("products.addToCatalog") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";

export default {
  props: ["product", "storeId"],

  mixins: [common, mask],

  components: {
    Money
  },

  data() {
    return {
      p: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      },
      vp: 0,
      vat: 0
    };
  },

  methods: {
    addToCatalog() {
      if (!this.p) {
        this.alertError({ message: "INVALID_PRICE" });
        return;
      }
      const p = Number(String(this.p.toFixed(2)).replace(/[^0-9]+/g, ""));
      const vp = Number(String(this.vp.toFixed(2)).replace(/[^0-9]+/g, ""));
      this.$emit("save-product", {
        product: {
          ...this.product,
          p,
          vp,
          vat:
            this.storeBeingManaged.address.countryCode === "PT"
              ? this.vat
              : undefined
        },
        storeId: this.storeId
      });
    }
  },

  computed: {
    ...mapGetters([
      "storeBeingManaged",
      "payments",
      "permissions",
      "getVatValues",
      "storeHasVAT"
    ])
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;

    if (this.storeBeingManaged.address.countryCode === "PT") {
      this.vat = this.storeBeingManaged.taxes.defaultVAT;
    }
  }
};
</script>
